"use client";

import { TimelineContent } from "politicamente-informados-ds";
import React from "react";

interface Party {
    title:
    | string
    | number
    | boolean
    | React.ReactElement
    | Iterable<React.ReactNode>
    | null
    | undefined;
    acf: {
        name?: string;
        url: string;
        logo: {
            url?: string;
        };
    };
}

interface Grid {
    items?: Party[];
}

interface Attrs {
    className?: string;
    style?: Record<string, unknown>;
    grid?: Grid;
}


const TimeLineContent: React.FC<any> = ({ attrs }) => {
    const { grid } = attrs;

    return (
        <TimelineContent items={grid.items} />
    );
};

export default TimeLineContent;
